import React from 'react';
export const WalletIcon = _ref => {
  let {
    wallet,
    ...props
  } = _ref;
  return wallet && React.createElement("img", {
    src: wallet.adapter.icon,
    alt: `${wallet.adapter.name} icon`,
    ...props
  });
};